import React, { Component } from "react";
import { toast } from "react-toastify";
import _ from "lodash";

import FileInput from "../../common/file/fileInput";
import DragDrop from "../../common/file/dragDrop";
import Preview from "../../common/file/preview";
import Status from "../../common/file/status";
import Filter from "../../common/filter";
import Back from "../../common/form/back";

import {
  updateFile,
  getFiles,
  uploadFiles,
  getFolders,
} from "../../../services/fileService";

class FilesForm extends Component {
  constructor(props) {
    super(props);
    this.selectFiles = this.selectFiles.bind(this);
    this.upload = this.upload.bind(this);
    this.handleUpload = this.handleUpload.bind(this);

    this.state = {
      images: [],
      labels: [],
      previewImages: [],
      selectedImages: undefined,
      folders: [],
      selectedFolder: null,
      progresses: [],
      messages: [],
      data: { file: "" },
    };
  }

  async componentDidMount() {
    // Get Folders and Modify
    const { data: allFolders } = await getFolders("public");
    if (allFolders.length === 0) return;

    // When at least a folder exists in the directory
    const data = allFolders.map((folder) => ({
      _id: folder,
      name: folder,
    }));

    const folders = [{ _id: "", name: "public" }, ...data];

    this.setState({ folders });

    // Check URL id
    const fileName = this.props.match.params.id;
    if (fileName === "new") return;

    // Get Files and Modify
    const { data: files } = await getFiles("public");
    if (files.length === 0) return;

    // When at least a File exists in the Folder
    const file = files.find((f) => f.name === fileName);
    if (!file) return this.props.history.replace("/not-found");

    this.mapToDataUrl(file.url).then((dataUrl) => {
      // Get Folder
      const folder = folders.find((f) => f.name === file.parent);
      // Load Label
      const label = [];
      label.push(file.name);
      // Load file
      const previewImage = [];
      previewImage.push(dataUrl);

      this.setState({
        selectedFolder: folder,
        data: this.mapToViewModel(file),
        labels: label,
        previewImages: previewImage,
      });
    });
  }

  // Cath File from an Url and map it to Data Url
  mapToDataUrl = (url) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  //Remove File Extension
  removeFileExtension = (name) => {
    const index = name.lastIndexOf(".");
    return name.slice(0, index);
  };

  // Map File to State
  mapToViewModel(file) {
    return {
      name: this.removeFileExtension(file.name),
      url: file.url,
      parent: file.parent,
    };
  }

  // Drag and Drop File select Event Handler
  handleDragDrop = (files) => {
    const images = [];

    for (let i = 0; i < files.length; i++) {
      images.push(URL.createObjectURL(files[i]));
    }

    this.setState({
      progresses: [],
      messages: [],
      selectedImages: files,
      previewImages: images,
    });

    if (files) {
      const fileNameObject = _.mapValues(files, function (o) {
        return o.name;
      });
      const labels = Object.keys(fileNameObject).map(function (key) {
        return fileNameObject[key];
      });

      this.setState({ labels });
    }
  };

  // Get uploaded Files from Browser
  selectFiles(event) {
    const images = [];

    for (let i = 0; i < event.target.files.length; i++) {
      images.push(URL.createObjectURL(event.target.files[i]));
    }

    this.setState({
      progresses: [],
      messages: [],
      selectedImages: event.target.files,
      previewImages: images,
    });

    if (event.target.files) {
      const fileNameObject = _.mapValues(event.target.files, function (o) {
        return o.name;
      });
      const labels = Object.keys(fileNameObject).map(function (key) {
        return fileNameObject[key];
      });

      this.setState({ labels });
    }
  }

  // Upload Files function
  async upload(index, file, header) {
    const progressInfos = [...this.state.progresses];

    await uploadFiles(file, header, (event) => {
      progressInfos[index].percentage = Math.round(
        (100 * event.loaded) / event.total
      );
      this.setState({ progresses: progressInfos });
    })
      .then(() => {
        this.setState((prev) => {
          const nextMessage = [
            ...prev.messages,
            `${file.name} \n Successfully uploaded!`,
          ];
          return { messages: nextMessage };
        });
        // Upload Result Message
        toast.success(`${file.name} \n Successfully uploaded!`);

        // Get Files after upload
        let path;
        if (this.state.selectedFolder) {
          path = this.state.selectedFolder._id;
        } else {
          path = "";
        }
        return getFiles(path === "" ? "public" : `public/${path}`);
      })
      .then((files) => {
        this.setState({ images: files.data });
      })
      .catch(() => {
        progressInfos[index].percentage = 0;

        this.setState((prev) => {
          let nextMessage = [
            ...prev.messages,
            `${file.name} \n
            Can not upload the file.`,
          ];
          return {
            progresses: progressInfos,
            messages: nextMessage,
          };
        });

        // Upload Result Message
        toast.error(`${file.name} \n Can not upload the file.`);
      });
    // Back to Files after Upload finished
    this.props.history.push("/dashboard/files");
  }
  // Upload Button Evenet Handler
  handleUpload() {
    const selectedImages = this.state.selectedImages;
    const path = this.state.selectedFolder;
    const header = path ? `public/${path}` : "public";

    let progressInfos = [];

    for (let i = 0; i < selectedImages.length; i++) {
      progressInfos.push({ percentage: 0, fileName: selectedImages[i].name });
    }

    this.setState(
      {
        progresses: progressInfos,
        messages: [],
      },
      () => {
        for (let i = 0; i < selectedImages.length; i++) {
          this.upload(i, selectedImages[i], header);
        }
      }
    );
  }

  // Filter Event Handler
  handleFolderSelect = ({ currentTarget: input }) => {
    const folder = this.state.folders.find((f) => f._id === input.value);

    this.setState({
      selectedFolder: folder,
    });
  };

  // Rename Input Event Handler
  handleRename = ({ currentTarget: input }) => {
    const data = { ...this.state.data };

    data["name"] = input.value;

    this.setState({ data });
  };

  // Save Button Event Handler
  handleSave = async (e) => {
    const data = { ...this.state.data };
    // Current File Name
    const currentFileName = this.props.match.params.id;
    // New File Name with extension append
    const index = currentFileName.lastIndexOf(".");
    const newFileName = data.name + currentFileName.slice(index);
    // Current File Path
    const currentFilePath = data.parent;
    // New File Path
    const newFilePath = this.state.selectedFolder._id;

    if (currentFileName !== newFileName || currentFilePath !== newFilePath) {
      // Update data with New file
      data["name"] = newFileName;
      data["parent"] = newFilePath;

      try {
        const response = await updateFile("public", currentFileName, data);
        if (response.data && response.status === 200) {
          toast.success(response.data.message);
        }
      } catch (ex) {
        if (ex.response && ex.response.status === 401) {
          toast.error("Only Admins can updated a File!");
        } else if (ex.response && ex.response.status === 404) {
          toast.error("This File has already been updated.");
        } else if (ex.response && ex.response.status === 500) {
          toast.error("This File can not be updated.");
        }
      }
      // Back to Files after Upload finished
      this.props.history.push("/dashboard/files");
    }
  };

  // Back button Event Handler
  handleBack = () => {
    this.props.history.push("/dashboard/files");
  };

  render() {
    const id = this.props.match.params.id;
    const {
      labels,
      previewImages,
      selectedImages,
      folders,
      selectedFolder,
      progresses,
      messages,
      data,
    } = this.state;

    return (
      <div className="col alt-table-responsive mt-1 mb-1">
        <div className="row align-items-center mt-1 mb-2 underline">
          <div className="col mt-2">
            <h2 className="mt-2">
              <i className="bx bxs-file-blank"></i>{" "}
              {id === "new" ? "Upload a new File" : "Edit File Details"}
            </h2>
          </div>
        </div>

        <div className="row align-items-center pt-2 my-2">
          <div className="col-12">
            <DragDrop onChange={this.handleDragDrop} />
          </div>
          {/* <div className="col-sm-6">
              <div className="row mt-3">
                <div className="col-sm-4"></div>
              </div>
            </div>
            <div className="col-sm-6"></div> */}
        </div>

        <div className="row pt-2 my-2">
          <div className="col-sm-6">
            <div className="py-1">
              <Filter
                name={"folder"}
                label={"Folder"}
                options={folders}
                selectedOption={selectedFolder}
                onChange={this.handleFolderSelect}
              />
            </div>
            <div className="py-1 pt-2">
              <Preview images={previewImages} label={"Preview"} />
            </div>
          </div>

          <div className="col-sm-6">
            <div className="py-1">
              <FileInput
                display={id === "new" ? true : false}
                name={"image"}
                label={labels}
                accept={"audio/*,video/*,image/*,application/pdf"}
                onChange={this.selectFiles}
                handleRename={this.handleRename}
                value={data.name}
                file={id}
              />
            </div>
            <div className="py-1 pt-2">
              <Status infos={progresses} message={messages} />
            </div>
          </div>
        </div>

        {/* <hr />

          <div className="row">
            <div className="col-sm-6"></div>

            <div className="col-sm-6"></div>
          </div>
          <div className="row">
            <div className="col-sm-6"></div>

            <div className="col-sm-6"></div>
          </div> */}

        <hr />

        <div className="row justify-content-between align-items-center mt-3 pb-2">
          <div className="col">
            <Back onClick={this.handleBack} />
          </div>

          <div className="col text-end">
            {id === "new" && (
              <button
                className="btn btn-success rounded"
                onClick={this.handleUpload}
                disabled={selectedImages ? false : true}
              >
                <i className="fa fa-upload" aria-hidden="true"></i> Upload
              </button>
            )}
            {id !== "new" && (
              <button
                className="btn btn-success rounded"
                onClick={this.handleSave}
                // disabled={selectedImages}
              >
                <i className="fa fa-floppy-o" aria-hidden="true"></i> Save
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default FilesForm;
